const DropdownMenuTheme = {
  menu: "absolute z-[1000] float-left m-0.5 min-w-max list-none overflow-hidden rounded-lg border-none bg-white bg-clip-padding text-left text-base shadow-lg dark:bg-neutral-700",
  fade: "transition-opacity duration-300 ease-linear motion-reduce:transition-none",
};

export default DropdownMenuTheme;
